import InsuranceESGDetailPie from '../components/InsuranceESGDetailsPie'
import JsPDF from 'jspdf'
import html2Canvas from 'html2canvas'
export default {
  components: {'esg-risk-detail-pie': InsuranceESGDetailPie},
  data() {
    return {
      first_info_show: false,
      second_info_show: false,
      data: null,
      counts: [0,0,0]
    }
  },
  methods: {
    countAdd(i,t) {
      if (this.counts[i]>4) return
      if (t) this.counts.splice(i,1,++this.counts[i])
    },
    countSubtract(i,t) {
      if (this.counts[i]<-4) return
      if (t) this.counts.splice(i,1,--this.counts[i])
    },
    levelStyle() {
      let level = this.$refs.details_level
      if(this.data){
        if(this.data.esg_==="A") level.className = 'details-level-A'
        if(this.data.esg_==="B") level.className = 'details-level-B'
        if(this.data.esg_==="C") level.className = 'details-level-C'
        if(this.data.esg_==="D") level.className = 'details-level-D'
      }
    },
    downloadPdf() {
      var title = '保险esg'
      html2Canvas(document.getElementsByClassName('risk-details-content')[0], {
        allowTaint: true
      }).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28 - 20
          let imgHeight = (592.28 - 20) / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 2.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 10, 20, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        }
      )
    }
  },
  created() {
    if(window.sessionStorage.getItem('ins_esg_details')) this.data = JSON.parse(window.sessionStorage.getItem('ins_esg_details'))
  },
  mounted() {
    this.levelStyle()
  },
  computed: {
    e_risk() {
      return parseInt(this.data.Environmental + this.counts[0])
    },
    s_risk() {
      return parseInt(this.data.Social + this.counts[1])
    },
    g_risk() {
      return parseInt(this.data.Governance + this.counts[2])
    },
    esg_risk() {
      return this.e_risk + this.s_risk + this.g_risk
    },
    title() {
      return this.data.insurance_num + ' ESG 风险分析明细'
    },
    insurance_rate() {
      return (this.data.insurance_fee / this.data.pay_limit * 100).toFixed(2) + '%'
    }
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_details.js